// Default column configuration for Donation child table
export const DEFAULT_DONATION_COLUMNS = [
  {
    id: 'actions',
    label: 'Actions',
    field: 'actions',
    visible: true,
    required: true, // Cannot be hidden
    width: 140,
    sticky: true, // Stays fixed on left
  },
  {
    id: 'transactionId',
    label: 'Transaction ID',
    field: 'transactionId',
    visible: true,
    required: false,
    width: 130,
  },
  {
    id: 'bookNo',
    label: 'Book No',
    field: 'bookNo',
    visible: true,
    required: false,
    width: 90,
  },
  {
    id: 'receiptNo',
    label: 'Receipt No',
    field: 'receiptNo',
    visible: true,
    required: false,
    width: 110,
  },
  {
    id: 'receiptDate',
    label: 'Receipt Date',
    field: 'receiptDate',
    visible: true,
    required: false,
    width: 130,
  },
  {
    id: 'amount',
    label: 'Amount',
    field: 'totalAmount',
    visible: true,
    required: false,
    width: 100,
  },
  {
    id: 'payMode',
    label: 'Pay Mode',
    field: 'payMode',
    visible: true,
    required: false,
    width: 110,
  },
  {
    id: 'bankName',
    label: 'Bank Name',
    field: 'bankName',
    visible: true,
    required: false,
    width: 150,
  },
  {
    id: 'instrumentNo',
    label: 'Instrument No',
    field: 'instrumentNo',
    visible: true,
    required: false,
    width: 140,
  },
  {
    id: 'instrumentDate',
    label: 'Instrument Date',
    field: 'instrumentDate',
    visible: true,
    required: false,
    width: 150,
  },
  {
    id: 'upiId',
    label: 'UPI Tnx ID',
    field: 'upiId',
    visible: true,
    required: false,
    width: 160,
  },
  {
    id: 'payPurpose',
    label: 'Pay Purpose',
    field: 'payPurpose',
    visible: true,
    required: false,
    width: 130,
  },
  {
    id: 'donationRemarks',
    label: 'Donation Remarks',
    field: 'donationRemarks',
    visible: true,
    required: false,
    width: 180,
  },
];

// Parent table columns (Donor list)
export const DEFAULT_DONOR_LIST_COLUMNS = [
  {
    id: 'expand',
    label: '',
    field: 'expand',
    visible: true,
    required: true,
    width: 60,
  },
  {
    id: 'actions',
    label: 'Actions',
    field: 'actions',
    visible: true,
    required: true,
    width: 100,
  },
  {
    id: 'donorId',
    label: 'Donor ID',
    field: 'donorId',
    visible: true,
    required: false,
    width: 100,
  },
  {
    id: 'firstName',
    label: 'First Name',
    field: 'firstName',
    visible: true,
    required: false,
    width: 150,
  },
  {
    id: 'lastName',
    label: 'Last Name',
    field: 'lastName',
    visible: true,
    required: false,
    width: 150,
  },
  {
    id: 'city',
    label: 'City',
    field: 'city',
    visible: true,
    required: false,
    width: 120,
  },
  {
    id: 'mobile',
    label: 'Mobile',
    field: 'mobile1',
    visible: true,
    required: false,
    width: 130,
  },
];
